import http from '../_http'

const signup = {
  //default
  summarySignup : (m) => { return http.get(`manager/management/signup`, m); },
  listSignup : (m) => { return http.post(`manager/management/signup/list`, m); },
  detailSignup : (m) => { return http.get(`manager/management/signup/${m.id}`); },

  //state
  acceptSignup : (m) => { return http.post(`manager/management/signup/accept`, m); },
  rejectSignup : (m) => { return http.post(`manager/management/signup/reject`, m); },
}

export default signup

export { signup }